// extracted by mini-css-extract-plugin
module.exports = {"home-doctor-list":"home-doctor-list--JcjIN","title":"title--2A_4z"};